<template>
  <!-- class="inner_menu" -->
  <div>
    <b-list-group>
      <router-link
        v-for="menu in DetailMenus"
        :key="menu.id"
        :to="menu.link.replace('{id}', id).replace('{moId}', id).replace('{moName}', moName)"
        class="list-group-item list-group-item-action menu_li"
        :class="{ active: menu.id === activeItem }"
        @click.native="setActive(menu.id)"
      >
        <b-icon :icon="menu.icon"></b-icon> {{ menu.label }}
      </router-link>
    </b-list-group>
  </div>
</template>
<script>
  export default {
    props: {
      activeItem: String,
      DetailMenus: Array,
      id: String,
      maId: String,
      maName: String,
      taskId: String,
      taskName: String,
      storeId: String,
      storeName: String,
      moId: String,
      moName: String,
    },
    methods: {
      setActive(id) {
        this.activeItem = id
      },
    },
  }
</script>
<style scoped>
  /* .inner_menu {
  border-right: 1px solid #EDF1FA;
} */

  .menu_li {
    border: none;
  }

  .menu_li:hover {
    background-color: #268dfc;
    color: #fff;
    cursor: pointer;
  }
</style>
